// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightLanding-cls1_7GZ","cls2":"CiterightLanding-cls2_QMT CiterightLanding-cls1_7GZ"};